/**
 * Created by piotr.pozniak@thebeaverhead.com on 12/06/2020.
 */

import React, { useCallback, useContext } from "react";

import PropTypes from "prop-types";
import EventBadges from "../EventBadges";
import EventHeaderTime from "./EventHeaderTime";
import WidgetSettingsContext from "../../../../contexts/WidgetSettingsContext";
import { formatDate, isSameDay } from "../../../../helpers/date";
import PrivateEventBadge from "../PrivateEventBadge";
import classNames from "classnames";
import CalendarLinkingContext from "../../../../contexts/CalendarLinkingContext";

const EventHeader = (props) => {
  const { event, embedded } = props;
  const calendarSettingsContext = useContext(WidgetSettingsContext);
  const calendarLinkingContext = useContext(CalendarLinkingContext);

  const onCardClickLock = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }, []);

  /**
   *
   * @type {(function(*): void)|*}
   */
  const onHeaderClick = useCallback(
    (e) => {
      if (calendarLinkingContext.selectedEventSlug === event.slug) {
        calendarLinkingContext.onCloseOpenedEventsDetails(e);
      } else {
        calendarLinkingContext.onClickEvent(event)(e);
      }
    },
    [
      calendarLinkingContext.selectedEventSlug,
      calendarLinkingContext.onClickEvent,
      calendarLinkingContext.onCloseOpenedEventsDetails,
      event.slug,
    ]
  );

  const showLocation =
    Number.parseInt(calendarSettingsContext["eLShowLocation"]) === 1;

  const startDate = new Date(event.start_time * 1000);
  const endDate = new Date(event.end_time * 1000);

  const isLastDays = !isSameDay(startDate, endDate);

  const endContainer = isLastDays ? (
    <div className="events-list--end-day-container">
      <div>{formatDate(endDate, { day: "2-digit" })}</div>
      <small>{formatDate(endDate, { month: "short" }).toLowerCase()}</small>
    </div>
  ) : null;

  const location =
    showLocation && event.display_location ? (
      <p>
        <i className="material-icons">location_on</i>
        {" " + event.display_location}
      </p>
    ) : null;

  const privateEventBadge =
    event.is_private * 1 == 1 && !embedded ? <PrivateEventBadge /> : null;

  const inlineStyles = {};

  if (props.useEventAccent && event.accentColor) {
    inlineStyles.backgroundColor = event.accentColor;
  }

  const eventBadges =
    (props.showRecurringBadge && event.recurrence_description) ||
    props.showFeaturedBadge ? (
      <EventBadges
        showRecurringBadge={
          props.showRecurringBadge && event.recurrence_description
        }
        showFeaturedBadge={props.showFeaturedBadge && event.is_featured}
      />
    ) : null;

  const content = props.showSummary ? (
    <div className="events-list--row">
      {privateEventBadge}

      <div className="events-list--date-container">
        <div className="events-list--day-container">
          <div className="dce__h1">
            {formatDate(startDate, { day: "2-digit" })}
          </div>
          <div className="dce__h4">
            {formatDate(startDate, { month: "short" })}
          </div>
        </div>

        <div className="events-list--end-date-container">{endContainer}</div>
      </div>

      <div>
        <div className="events-list--event-description">
          {eventBadges}
          <h2>{event.name}</h2>
          <EventHeaderTime
            startDate={startDate}
            endDate={endDate}
            isSpanningAcrossDays={isLastDays}
            showWeekDay={props.showWeekDay}
            weekDayFormatter={props.weekDayFormatter}
            isAllDayEvent={event.allDay}
          />
          {location}
        </div>
      </div>
    </div>
  ) : null;

  return (
    <a
      href={calendarLinkingContext.getEventUrl(event)}
      title={event.name}
      aria-label={"Event: " + event.name}
      className={classNames({
        "events-list--row-wrapper": true, //calendar.model.temlate === CT.monthly,
      })}
      style={inlineStyles}
      onMouseUp={onCardClickLock}
      onMouseDown={onCardClickLock}
      onClick={onHeaderClick}
    >
      {content}
    </a>
  );
};

EventHeader.propTypes = {
  event: PropTypes.object,
  embedded: PropTypes.bool,
  onClick: PropTypes.func,
  showWeekDay: PropTypes.bool,
  weekDayFormatter: PropTypes.string,
  useEventAccent: PropTypes.bool,
  showSummary: PropTypes.bool,
  showRecurringBadge: PropTypes.bool,
  showFeaturedBadge: PropTypes.bool,
};

EventHeader.defaultProps = {
  showWeekDay: false,
  weekDayFormatter: "",
  useEventAccent: false,
  showSummary: true,
};

//Row.whyDidYouRender = true
export default EventHeader;
